module.exports = __webpack_public_path__ + "static/media/test_removeHeaderEndings_order.29fbda9b.csv";